import React from "react";
import AppCard from "../../components/card";
import { Box, Grid } from "@mui/material";

const Dashboard = ({ cart, products, onAddCart, onDeleteProduct }) => {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        pb: 10,
      }}
    >
      <Grid
        container
        spacing={2}
        justifyContent="center"
        sx={{
          width: "100%",
          maxWidth: 1400,
        }}
      >
        {products.map((card) => (
          <Grid
            item
            key={card.id}
            xs={12}
            sm={6}
            md={4}
            lg={3}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <AppCard
              {...card}
              cartQuantity={
                cart.find((item) => item.product_code === card.product_code)
                  ?.quantity || 0
              }
              onAddCart={onAddCart}
              onDeleteProduct={onDeleteProduct}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Dashboard;
